module.exports = __webpack_public_path__ + "static/media/paladion.3b7fa3d0.png";